import { FC, ReactNode } from "react";
import { Box } from "@chakra-ui/react";

interface Props {
  show: boolean;
  children: ReactNode;
}

export const ExpandableBox: FC<Props> = ({ show, children }) => {
  return (
    <Box
      style={{
        maxHeight: show ? "none" : "0",
        opacity: show ? 1 : 0,
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
};
